<template>
  <a-list
    size="large"
    rowKey="id"
    :loading="loading"
    itemLayout="vertical"
    :dataSource="data"
  >
    <template v-slot:renderItem="item">
      <a-list-item :key="item.id">
        <template v-slot:actions> </template>
        <a-list-item-meta>
          <template v-slot:title>
            <a href="https://vue.ant.design/">{{ item.title }}</a>
          </template>
          <template v-slot:description>
            <span>
              <a-tag>Ant Design</a-tag>
              <a-tag>设计语言</a-tag>
              <a-tag>蚂蚁金服</a-tag>
            </span>
          </template>
        </a-list-item-meta>
        <article-list-content
          :description="item.description"
          :owner="item.owner"
          :avatar="item.avatar"
          :href="item.href"
          :updateAt="item.updatedAt"
        />
      </a-list-item>
    </template>
    <template v-slot:footer>
      <div v-if="data.length > 0" style="text-align: center; margin-top: 16px">
        <a-button @click="loadMore" :loading="loadingMore">加载更多</a-button>
      </div>
    </template>
  </a-list>
</template>

<script>
import { ArticleListContent } from '@/components'

export default {
  name: 'Article',
  components: {
    ArticleListContent,
  },
  data() {
    return {
      loading: true,
      loadingMore: false,
      data: [],
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    getList() {
      for (let i = 0; i < 11; i++) {
        this.data.push({
          id: i,
          title: 'Alipay',
          avatar:
            'https://gw.alipayobjects.com/zos/rmsportal/WdGqmHpayyMjiEhcKoVE.png',
          description:
            '在中台产品的研发过程中，会出现不同的设计规范和实现方式，但其中往往存在很多类似的页面和组件，这些类似的组件会被抽离成一套标准规范。',
          star: 20,
          like: 20,
          message: 20,
          owner: '付小小',
          href: 'https://ant.design',
          updatedAt: '2020-07-22 23:11:33',
        })
      }
      this.loading = false
    },
    loadMore() {
      this.loadingMore = true
    },
  },
}
</script>
